import type { TranslatedString } from '@interfaces/shared';
import type { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { CreateAssetTemplateVisual } from './createAssetTemplate.visual';

export type CreateAssetTemplateProps = {
  options: CreateAssetTemplateOptions;
  onNext: () => void;
  stepLoading: boolean;
};

export type CreateAssetTemplateOptions = {
  enabled: boolean;
  canGoBack: boolean;
  required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
  label: TranslatedString;
  description: TranslatedString;
  templateName: {
    enabled: boolean;
    required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
    label: TranslatedString;
  };
  templateDescription: {
    enabled: boolean;
    required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
    label: TranslatedString;
  };
  assetClassAllocationEditor: {
    enabled: boolean;
    required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
    label: TranslatedString;
    assetClassAllocation: {
      enabled: boolean;
      required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
      label: TranslatedString;
    };
    targetPercentage: {
      enabled: boolean;
      required: FieldRequiredType.ERROR | FieldRequiredType.NOT_REQUIRED;
      label: TranslatedString;
    };
  };
  buttonCreate: {
    enabled: boolean;
    label: TranslatedString;
  };
};

export const CreateAssetTemplate = ({
  options,
  onNext,
  stepLoading,
}: CreateAssetTemplateProps) => {
  const handleComplete = async () => {
    onNext();
  };

  return (
    <CreateAssetTemplateVisual
      options={options}
      onComplete={handleComplete}
      loading={stepLoading}
    />
  );
};
